import { render, staticRenderFns } from "./AddWorkflowGroup.vue?vue&type=template&id=7562f74e&scoped=true"
import script from "./AddWorkflowGroup.vue?vue&type=script&lang=js"
export * from "./AddWorkflowGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7562f74e",
  null
  
)

export default component.exports